<template>
	<InfoBox>
        <SvgIcon slot="icon" icon="security"></SvgIcon>
        <span slot="bold">{{$t('infobox.security.headline')}}</span>
        <span slot="text">{{$t('infobox.security.text')}}</span>
    </InfoBox>
</template>
<script>
    import Vue from 'vue';
    import SvgIcon from './Svg.vue';
    import InfoBox from './InfoBox.vue';
    export default {
    	components:{
			SvgIcon,
			InfoBox
		},
		data: () => ({
	
		})
	}
</script>